import ImageUploader from "./ImageUploader";

type Props = {
  value: string[];
  onChange: (paths: string[]) => void;
  prefix: string;
};

const GalleryUploader = ({ value, onChange, prefix }: Props) => {
  const add = (path: string | null) => {
    if (path) onChange([...value, path]);
  };
  const replace = (idx: number, path: string | null) => {
    const next = [...value];
    if (path) next[idx] = path;
    else next.splice(idx, 1);
    onChange(next);
  };

  return (
    <div className="space-y-3">
      <p className="text-xs text-muted-foreground">
        Additional images (the first image in the main field above is the cover).
      </p>
      {value.map((p, i) => (
        <ImageUploader
          key={`${p}-${i}`}
          value={p}
          onChange={(np) => replace(i, np)}
          prefix={prefix}
        />
      ))}
      <div className="border-t border-dashed border-border pt-3">
        <p className="text-xs font-semibold mb-1">Add another image</p>
        <ImageUploader value={null} onChange={add} prefix={prefix} />
      </div>
    </div>
  );
};

export default GalleryUploader;
